module.exports = __webpack_public_path__ + "static/images/banner-new2.0fbbdf0.png";